import CryptoJS from "crypto-js";
import CONFIG from "../config";

export const decryptPayload = (encryptedResponse) => {
  try {
    const responseAesKey = CryptoJS.enc.Utf8.parse(
      CONFIG.REQUEST_RESPONSE_ENCRYPTION.response_aes_key
    );

    const zeroIv = CryptoJS.lib.WordArray.create(new Array(4).fill(0));

    const decryptedSymmetricKeyBase64 = CryptoJS.AES.decrypt(
      encryptedResponse.encrypted_symmetric_key,
      responseAesKey,
      {
        iv: zeroIv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    ).toString(CryptoJS.enc.Utf8);

    const symmetricKey = CryptoJS.enc.Base64.parse(decryptedSymmetricKeyBase64);

    const ivWordArray = CryptoJS.enc.Base64.parse(encryptedResponse.iv);

    const decryptedData = CryptoJS.AES.decrypt(
      encryptedResponse.encrypted_data,
      symmetricKey,
      {
        iv: ivWordArray,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    ).toString(CryptoJS.enc.Utf8);

    return JSON.parse(decryptedData);
  } catch (error) {
    console.error(`Decryption failed: `, error);
    throw new Error("Failed to decrypt response");
  }
};
